import React from 'react';

import { IconAngleLeft, IconAngleRight } from '../..';

/**
 * @typedef {ScrollButtonContentProps}
 * @property {boolean} disabled whether this button is disabled
 * @property {string} direction direction for the icon to point
 */
interface ScrollButtonContentProps {
    disabled?: boolean;
    direction: 'left' | 'right';
}

const width = 40;
const iconWidth = 35;

/**
 * Content for a button that allows scrolling to the next / previous slide.
 * @param {ScrollButtonContentProps} props
 */
export const ScrollButtonContent = ({
    disabled = false,
    direction,
}: ScrollButtonContentProps): JSX.Element => {
    const Icon = direction === 'left' ? IconAngleLeft : IconAngleRight;

    return (
        <div
            className="rounded-full flex items-center justify-center shadow-lg bg-highlight-palelavender"
            style={{ width, height: width }}
        >
            <Icon
                fillColor={disabled ? 'tertiary-300' : 'primary-500'}
                width={iconWidth}
            />
        </div>
    );
};
